import { namespacedConsts, } from 'utils/object';


export const FACEBOOK_BOT_ACTION_TYPES = namespacedConsts({
  GO_TO_MESSENGER_BOT: true,
});


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/facebook_bot/facebookBotActionTypes.js